<div class="borrow-page">
  <div class="borrow-card">
    <h2>Udlån</h2>

    <div class="form-section">
      <app-dialog-input-title title="Initialer"></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [(ngModel)]="equipmentBorrow.initials" />
    </div>

    <div class="form-section">
      <app-dialog-input-title title="Lokation"></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [(ngModel)]="equipmentBorrow.locationName" />
    </div>

    <div class="form-section">
      <app-dialog-input-title title="Forventet retur" [required]="true"></app-dialog-input-title>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput
               [matDatepicker]="expectedReturnDatePicker"
               [(ngModel)]="equipmentBorrow.expectedReturnDate"
               name="expectedReturnDate"
               readonly
               (click)="expectedReturnDatePicker.open()" />
        <mat-datepicker-toggle matIconSuffix
                               [for]="expectedReturnDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #expectedReturnDatePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="form-section">
      <app-dialog-input-title title="Projekt nr."></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [(ngModel)]="equipmentBorrow.projectNr" />
    </div>

    <div class="form-section">
      <app-dialog-input-title title="Udlån bemærkning"></app-dialog-input-title>
      <input class="text-input"
                type="text"
                [(ngModel)]="equipmentBorrow.borrowedComment"/>
    </div>

    <button mat-flat-button
            color="primary"
            class="save-button"
            (click)="saveBorrow()"
            [disabled]="isBorrowSaveDisabled">
      Udlån
    </button>
  </div>
</div>
